import React from 'react';
import { observer } from 'mobx-react';
import { IESignAgreementConsent } from '../../../stores/service-finance.store';
import { Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import * as Styles from './esign-agreement-consent.less';

interface IESignAgreementProps {
    consents: IESignAgreementConsent;
    hasCoApplicant: boolean;
}

export const ESignAgreementConsent: React.FC<IESignAgreementProps> = observer(
    ({ consents, hasCoApplicant }) => {
        return (
            <>
                <div className={Styles.Title}>E-Sign Agreement</div>
                <div className={Styles.row}>
                    <div className={Styles.wideCol}>
                        <div className={Styles.subTitle}>Applicant</div>
                        <RadioGroup
                            row
                            value={consents.PrimaryApplicant}
                            onChange={(e, val) => (consents.PrimaryApplicant = val === 'true')}
                        >
                            <FormControlLabel
                                value="true"
                                control={<Radio className={Styles.radio} />}
                                label="Yes, I consent"
                                disabled={!consents.scrolledToBottom}
                            />
                            <FormControlLabel
                                value="false"
                                control={<Radio className={Styles.radio} />}
                                label="No, I do not consent"
                                disabled={!consents.scrolledToBottom}
                            />
                        </RadioGroup>
                    </div>
                    {hasCoApplicant && (
                        <div className={Styles.wideCol}>
                            <div className={Styles.subTitle}>Co-Applicant</div>
                            <RadioGroup
                                row
                                value={consents.CoApplicant}
                                onChange={(e, val) => (consents.CoApplicant = val === 'true')}
                            >
                                <FormControlLabel
                                    value="true"
                                    control={<Radio className={Styles.radio} />}
                                    label="Yes, I consent"
                                    disabled={!consents.scrolledToBottom}
                                />
                                <FormControlLabel
                                    value="false"
                                    control={<Radio className={Styles.radio} />}
                                    label="No, I do not consent"
                                    disabled={!consents.scrolledToBottom}
                                />
                            </RadioGroup>
                        </div>
                    )}
                </div>
            </>
        );
    }
);
